#import "@/components/common/LinkFragment.gql"

fragment SmallTopicFeatureBarsFragment on smallTopicFeatureBars_Entry {
  typeHandle
  heading
  cta {
    ...LinkFragment
  }
  topicCards {
    ... on topicCardsBlock_Entry {
      heading
      image {
        url
      }
      alt
      topic {
        ...LinkFragment
      }
    }
  }
}
